import React from 'react';
import { QuoteData } from '../../types';
import { formatCurrency, calculateMonthlySavings, calculateCurrentTotalMonthlyPayment, calculateProposedTotalMonthlyPayment } from '../../lib/calculations';
import { motion } from 'framer-motion';
interface KeyStatsProps {
  data: QuoteData;
}
export function KeyStats({
  data
}: KeyStatsProps) {
  const hasLiabilities = data.liabilities.some(l => l.monthlyPayment > 0);
  const currentTotal = calculateCurrentTotalMonthlyPayment(data.currentPayment, data.liabilities);
  const proposedTotal = calculateProposedTotalMonthlyPayment(data.proposedPayment, data.liabilities);
  const totalReduction = currentTotal - proposedTotal;
  const monthlySavings = calculateMonthlySavings(data.currentPayment, data.proposedPayment);
  const headlineValue = hasLiabilities ? totalReduction : monthlySavings;
  const isIncrease = headlineValue < 0;
  const thirdLabel = hasLiabilities ? isIncrease ? 'TOTAL MONTHLY INCREASE' : 'TOTAL MONTHLY SAVINGS' : isIncrease ? 'MONTHLY INCREASE' : 'MONTHLY SAVINGS';
  const thirdSubtext = hasLiabilities ? 'mortgage + remaining debts' : 'compared to current payment';
  const stats = [{
    label: 'CASH AT CLOSING',
    value: formatCurrency(data.cashToBorrower),
    subtext: 'wired to you after funding',
    highlight: true
  }, {
    label: 'NEW MONTHLY PAYMENT',
    value: formatCurrency(data.proposedPayment),
    subtext: `${formatCurrency(data.proposedPayment)} P&I`,
    highlight: false
  }, {
    label: thirdLabel,
    value: formatCurrency(Math.abs(headlineValue)),
    subtext: thirdSubtext,
    highlight: !isIncrease,
    neutral: isIncrease
  }];
  return <div className="bg-charcoal-800 rounded-2xl border border-white/10 overflow-hidden" data-id="element-43">
      <div className="grid grid-cols-1 md:grid-cols-3 divide-y md:divide-y-0 md:divide-x divide-white/10" data-id="element-44">
        {stats.map((stat, index) => <motion.div key={stat.label} initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.2 * index,
        duration: 0.8,
        ease: 'easeOut'
      }} className="p-8 flex flex-col items-center justify-center text-center h-full" data-id="element-45">
            <div className="text-[10px] font-medium tracking-[0.2em] text-gray-500 mb-4" data-id="element-46">
              {stat.label}
            </div>
            <div className={`font-serif font-light text-4xl md:text-5xl mb-3 ${stat.highlight ? 'text-gold' : 'text-white'}`} data-id="element-47">
              {stat.value}
            </div>
            <div className="text-xs text-gray-500 font-light" data-id="element-48">
              {stat.subtext}
            </div>
          </motion.div>)}
      </div>
    </div>;
}